module.exports = __webpack_public_path__ + "img/tutorial-3.72daad9f.jpg";